var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"overflow-y-auto",staticStyle:{"position":"relative"}},[(_vm.authGubun === 'master')?_c('master-main',{attrs:{"authGubun":_vm.authGubun}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }